var map = {
	"./Actions.js": 86674,
	"./Buddy.js": 9925,
	"./Chat.js": 56283,
	"./Coins.js": 16319,
	"./Error.js": 81891,
	"./GameSession.js": 81323,
	"./Get.js": 32057,
	"./Igloo.js": 99943,
	"./Ignore.js": 85771,
	"./Item.js": 38410,
	"./Join.js": 28921,
	"./Login.js": 60172,
	"./Mail.js": 66954,
	"./MiniGame.js": 6772,
	"./NPC.js": 93822,
	"./Notifications.js": 55425,
	"./Pet.js": 4428,
	"./PlaytimeEnforcement.js": 19962,
	"./SeasonPass.js": 88092,
	"./Stamps.js": 83641,
	"./Storefront.js": 67517,
	"./Table.js": 84065,
	"./Waddle.js": 71950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59168;